import { Viewer } from "mapillary-js";
import { get, writable } from "svelte/store";
export class MapillaryImageViewerManager {
    constructor(parent, options) {
        this.visible = false;
        this.imageId = "";
        this.visibleStore = writable(false);
        this.parent = parent;
        this.options = options;
        this.visibleStore.subscribe(v => {
            if (typeof this.container === "undefined")
                return;
            if (v) {
                if (typeof this.viewer === "undefined") {
                    this.viewer = new Viewer({
                        accessToken: this.options.apiKey,
                        container: this.container,
                        imageId: this.imageId,
                        component: { cover: false },
                    });
                    this.viewer.on("image", (e) => {
                        const imageStore = this.parent.getImageIdStore();
                        if (get(imageStore) !== e.image.id) {
                            imageStore.set(e.image.id);
                        }
                    });
                }
                else {
                    //console.log(`moving viewer to ${this.imageId}`);
                    this.viewer.moveTo(this.imageId);
                }
            }
        });
    }
    resize() {
        if (typeof this.viewer === "undefined")
            return;
        //console.log("resized");
        this.viewer.resize();
    }
    getVisibleStore() {
        return this.visibleStore;
    }
    initialize(element) {
        const me = this;
        this.container = document.createElement("div");
        this.container.style.width = "100%";
        this.container.style.height = "100%";
        this.container.style.display = "inline-block";
        this.container.style.margin = "1px";
        element.appendChild(this.container);
        this.visibleStore.set(get(this.visibleStore));
    }
    setImageId(imageId) {
        if (this.imageId === imageId)
            return;
        this.imageId = imageId;
        if (!this.visible) {
            this.visibleStore.set(false);
            return;
        }
        if (typeof this.imageId === "undefined" || this.imageId.length == 0) {
            this.visibleStore.set(false);
            return;
        }
        this.visibleStore.set(true);
        if (typeof this.viewer !== "undefined") {
            this.viewer.moveTo(this.imageId);
            this.viewer.resize();
        }
    }
    hide() {
        this.visibleStore.set(false);
        if (typeof this.viewer !== "undefined") {
            this.viewer.remove();
            this.viewer = undefined;
        }
    }
    close() {
        this.parent.getVisibleStore().set(false);
    }
    show() {
        this.visible = true;
        if (typeof this.imageId === "undefined" || this.imageId.length == 0) {
            this.visibleStore.set(false);
            return;
        }
        this.visibleStore.set(true);
    }
}
